export var packages = {
    grainpro: 'GrainPro',
    ecotact: 'Ecotact',
    vacuum: 'Vacuum pack',
    klabin: 'Klabin',
    agave: 'Agave',
};
export var OrderTypeValues = ['basic', 'auction'];
